import { NgModule } from '@angular/core';
import { ConfigModule } from '@spartacus/core';
import { layoutConfig } from './layout.config';

@NgModule({
  imports: [ConfigModule.withConfig(layoutConfig)],
})
export class CmsStaticModule {}
